// extracted by mini-css-extract-plugin
module.exports = {"tooltipText":"style_tooltipText__uN9rt"};